import { useEffect, useRef, useState } from "react";
import { ConfirmDialog } from "./ui";

/**
 * "Complete task?" with an optional note — what happened on the call, the
 * visit, the follow-up. The note goes to PATCH /api/leads/tasks/:id/complete
 * as completion_notes; the backend keeps it on the task and in the lead's
 * activity history. Built on ConfirmDialog so it looks like every other
 * confirmation in the panel.
 */
export function CompleteTaskDialog({ task, onConfirm, onCancel }) {
  const [notes, setNotes] = useState("");
  const ref = useRef(null);
  // ConfirmDialog focuses its button; the note is what people type, so focus it after.
  useEffect(() => { const t = window.setTimeout(() => ref.current?.focus(), 30); return () => window.clearTimeout(t); }, []);
  return (
    <ConfirmDialog
      title="Complete task?"
      tone="positive"
      confirmLabel="Mark complete"
      onCancel={onCancel}
      onConfirm={() => onConfirm(notes.trim())}
      body={
        <div className="flex flex-col gap-3">
          <p className="text-small text-ink">{task?.title || "This task"}</p>
          <label htmlFor="complete-task-notes" className="text-caption font-medium text-muted">Notes (optional)</label>
          <textarea
            id="complete-task-notes"
            ref={ref}
            value={notes}
            maxLength={2000}
            rows={4}
            onChange={(event) => setNotes(event.target.value)}
            placeholder="What happened? e.g. Called, patient will visit on Friday"
            className="w-full resize-y rounded-md border border-line bg-paper px-3 py-2 text-small text-ink outline-none placeholder:text-muted focus:border-sky-deep"
          />
        </div>
      }
    />
  );
}
